import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Link, useNavigate } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import MpgInput from "../../../../CommonFormComp/MpgInput";
import IconButton from "@mui/material/IconButton";
import SearchIcon from '@mui/icons-material/Search';
import { useVerifyActiveAdminUserEmailIdFromADQuery } from "../../../../reactQueries/AppApi/rqHooksForAdminUser";
import { ConstructionOutlined } from "@mui/icons-material";
import { useQueryClient } from "@tanstack/react-query";

const SearchForActiveUserEmail = ({ setInputEmail,label,cmsValidationMsgLabels }) => {
  /**search component  */
  const fetchAdminUserValidationLabel = (key) => {
    return cmsValidationMsgLabels?.find((el) => el.Key === key)?.Phrase || '';
  }

  const schemaForSearch = yup.object().shape({
    searchEmail: yup.string().label('This field').email(fetchAdminUserValidationLabel('AdminUserValidationMsg.ValidEmail')).required(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')).max(200),
  });

  const rhfFormInstanceForsearch = useForm({
    resolver: yupResolver(schemaForSearch),
    defaultValues: {
      searchEmail: "",
    },
  });
  const onSubmitForSearch = (data, e) => {
    if (!!data?.searchEmail) {
      setInputEmail(data?.searchEmail)
    }
  };



  return (
    <>
      <Box>

        <MpgInput
          rhfFormInstance={rhfFormInstanceForsearch}
          name={"searchEmail"}
          label={label}
          fullWidth
          endAdornmentComponent={
            <IconButton
              type="button"
              sx={{ p: '10px' }}
              aria-label="search"
              onClick={(e) => {
                rhfFormInstanceForsearch.handleSubmit(onSubmitForSearch)(e)
              }}
            >
              <SearchIcon />
            </IconButton>
          }
        />
      </Box>
    </>
  );
};

export default SearchForActiveUserEmail;
